import { ControlTag } from "@istari/istari-client";

import { ControlTagSummary } from "../../model/control-tag";

export function toControlTagSummary(tag: ControlTag): ControlTagSummary {
  return {
    id: tag.id,
    name: tag.name,
    status: tag.status,
    displayColor: tag.displayColor ?? null,
    isExternallyManaged: Boolean(tag.upstreamRemoteInfo),
  };
}

export function toControlTagSummaries(tags: ControlTag[] | undefined): ControlTagSummary[] {
  return (tags ?? []).map(toControlTagSummary);
}
